import React, {useEffect, useState} from 'react'
import {setMoney} from "../../../utils/shared";
import ContainerComponent from "../../../components/elements/ContainerComponent";
import {TableWithStripedRows} from "../../../components/elements/Tables/TableComponent";
import {setDatetime} from "../../../utils/shared";

function ContainerReport(props) {
  const {listInventoryReport, data, loader} = props;
  const [didMount, setMount] = useState(false);
  const [params, setParams] = useState({});

  useEffect(() => {
    setMount(true)
  }, []);

  useEffect(() => {
    if (didMount) {
      listInventoryReport(params)
    }
  }, [didMount]);

  const columnsName = [
    {selector: row => row.branch_office, name: 'Sucursal'},
    {selector: row => row.user, name: 'Usuario'},
    {selector: row => row.action, name: 'Acción'},
    {selector: row =>  setDatetime(row.creation_date), name: 'Fecha y Hora'},
    {selector: row =>  `${row.product_name} (${row.product_presentation})`, name: 'Producto'},
    {selector: row => parseInt(row.previous_stock), name: 'Existencia Antes'},
    {selector: row => parseInt(row.last_stock), name: 'Existencia Después'},
  ]

  const Filters = [
    {
      placeholder: 'Sucursal',
      name_filter: 'branch_office_id',
      urlOptionList: 'branch-offices/select'
    },
    {
      placeholder: 'Usuario',
      name_filter: 'user_id',
      urlOptionList: 'user/select_option'
    },
    {
      placeholder: 'Fecha Inicio',
      name_filter: 'date_start',
      initialDate: new Date(),
    },
    {
      placeholder: 'Fecha Fin',
      name_filter: 'date_end',
      initialDate: new Date(),
    },
  ]

  const changeFilterById = (filterValue) => {
    let nuevosParametros = {}
    if (params && typeof (params) === 'object') {
      // Si ya existe un filtro que lo mantenga, y que sobrescriba su valor
      nuevosParametros = {...params, ...filterValue}
      setParams(nuevosParametros)
    } else {
      // de lo contrario que agregue ese filtro
      nuevosParametros = filterValue
      setParams(nuevosParametros);
    }
    setTimeout(()=>{
      console.log('nuevosParametros', nuevosParametros)
      listInventoryReport(nuevosParametros)
    }, 50)
  }

  const searchChange = (presentationName) => {
    changeFilterById({presentation_name: presentationName});
  }

  return (
    <ContainerComponent
      title={'Reporte de Movimientos de Productos'}
    >
      <div className="mt-2"></div>
      <TableWithStripedRows
        filters={Filters}
        loader={loader}
        data={data}
        changeFilter={changeFilterById}
        searchChange={searchChange}
        searchValue={props.search}
        dontShowAction={true}
        columns={columnsName}
      />
      <span className="opacity-90 font-thin">Historial de movimientos de productos</span>
    </ContainerComponent>
  )
}

export default ContainerReport;